module.exports = {
      id: "google-play-usage",
      viewBox: undefined,
      url: "/" + "sprite-94c0c4e617ccd395a266f9fdfc4a2687.svg#google-play",
      toString: function () {
        return this.url;
      }
    }